module.exports = __webpack_public_path__ + "img/resized-APP-0012-2.7b110ded.png";